var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// @ts-ignore
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import cxs from 'cxs/component';
import Theme from 'Theme';
import { Icon } from 'elements';
import theme from 'Theme';
let SceneBar = class SceneBar extends Component {
    render() {
        const { style } = this.props;
        return (React.createElement(Bar, { style: Object.assign({}, style) },
            React.createElement(StyledLink, { to: "/operationlines" },
                React.createElement(StyledIcon, { name: "catalog", size: 22 }),
                React.createElement(StyledP, null, "cat\u00E1logo")),
            React.createElement(StyledLink, { to: "/tickets" },
                React.createElement(StyledIcon, { name: "refund", size: 22 }),
                React.createElement(StyledP, null, "Tickets")),
            React.createElement(StyledLink, { to: "/menu" },
                React.createElement(StyledIcon, { name: "menu", size: 22 }),
                React.createElement(StyledP, null, "men\u00FA"))));
    }
};
SceneBar = __decorate([
    inject('store'),
    observer
], SceneBar);
export default SceneBar;
const Bar = cxs('div')({
    width: '100%',
    backgroundColor: 'white',
    display: 'flex',
    height: Theme.size.bar,
    textAlign: 'center',
    borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingLeft: '50px',
    paddingRight: '50px',
    borderTop: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
});
const StyledP = cxs('p')({
    margin: 0,
    padding: 0,
    fontSize: '10px',
    ':hover': {
        color: theme.color.primary,
    },
});
const StyledLink = cxs(Link)({
    textDecoration: 'none',
    textAlign: 'center',
    paddingTop: '5px',
    ':hover': {
        textDecoration: 'none',
        color: theme.color.primary,
    },
});
const StyledIcon = cxs(Icon)({
    margin: 0,
    padding: 0,
    ':hover': {
        color: Theme.color.primary,
    },
});



//////////////////
// WEBPACK FOOTER
// ./src/components/SceneBar.tsx
// module id = 544
// module chunks = 0